import * as net from 'util/Net';

export interface CanvasFolderArtifactPreviewResponse {
  signedUrl: string;
  expiresAt: number;
}

export function getCanvasFolderArtifactPreviewUrl(
  canvasFolderArtifactId: string,
  filePath: string = 'index.html'
): Promise<CanvasFolderArtifactPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/canvas-folder-artifacts/${canvasFolderArtifactId}:render`,
    data: {filePath},
  });
}
